// removed by extract-text-webpack-plugin
module.exports = {"editor":"editor___2KF_s"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/EditVariable/JavascriptEditor/styles.scss
// module id = 421
// module chunks = 0